import { State } from 'features/Frames/types';

export const stateWriter = (state: string): string => {
  switch (state) {
    case State.OK:
      return 'OK';
    case State.LOW_DELIVERY:
      return 'Low Delivery';
    case State.IN_ERROR:
      return 'In Error';
    case State.MIA:
      return 'MIA';
    default:
      return 'Deactivated';
  }
};

export const stateReader = (stateString: string): State => {
  const key = stateString as keyof typeof State;
  return State[key] || State.DEACTIVATED;
};

export const stateConstantWriter = (states: string[]): string[] => {
  return states.map((state) => {
    // Replace spaces with underscores and convert to uppercase
    return state.replace(/\s+/g, '_').toUpperCase();
  });
};
